import React from "react";

export default function SameSurfaceBooking({
  otherSurface,
  selectedOtherSurface,
  setSelectedOtherSurface,
  setSelectedSlots,
}) {
  return (
    <React.Fragment>
      <div className="row">
        <div className="col-12 mt-3 fw-500">
          Is any other turf/court available for Box Cricket at the same time?
        </div>
        <div className="col-12 mt-2">
          <select
            className="form-select"
            value={selectedOtherSurface}
            onChange={(e) => {
              setSelectedOtherSurface(e.target.value);
              setSelectedSlots([]);
            }}
          >
            {otherSurface?.map((surface) => (
              <option value={surface?.id}>{surface?.courtName}</option>
            ))}
          </select>
        </div>
      </div>
    </React.Fragment>
  );
}
